import React, { useState, useEffect } from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';

import asyncRoute from '../../helpers/hoc/asyncRoute';
import routes from '../../routes';


import { checkPermission, PrivateRoute } from '../../utils/route-auth';
import { MODULE_PERMISSIONS } from '../../constants/permission';
import { checkConnectionManagementAccess } from '../../selectors';

const Tenant = asyncRoute(() => import('./Tenant'));
// const SupplyPartner = asyncRoute(() => import('./SupplyPartner'));
// const Features = asyncRoute(() => import('./Features'));
const Variable = asyncRoute(() => import('./Variable'));
const User = asyncRoute(() => import('./User'));
const SubscriptionPlanMgr = asyncRoute(() => import('./SubscriptionPlanMgr'))
// const DemandPartner = asyncRoute(() => import('./DemandPartner'));
// const Roles = asyncRoute(() => import('./Roles'));
// const SupplyPath = asyncRoute(() => import('./SupplyPath/List'));
// const Agreement = asyncRoute(() => import('./Agreement'));
const NotAuthorize = asyncRoute(() => import('../NotAuthorize'));
const Account = asyncRoute(() => import('./Account'))
// const CurrencyRate = asyncRoute(() => import('./CurrencyRate'));
// const Platform = asyncRoute(() => import("./Platform"))
const Advertiser = asyncRoute(() => import('./Advertiser'))
// const AdvertiserPoc = asyncRoute(() => import('./Advertiser/POC'))
const AdvertiserNewDev = asyncRoute(() => import('./AdvertiserNewDev'));
const DataConfig = asyncRoute(() => import('./DataConfig'));
const ConnectionManagement = asyncRoute(() => import('./ConnectionManagement'))

const permissionArray = [
  MODULE_PERMISSIONS.ADMIN_TENANT,
  MODULE_PERMISSIONS.ADMIN_PROFILE,
  MODULE_PERMISSIONS.ADMIN_CONNECTION_MANAGEMENT,
  MODULE_PERMISSIONS.ADMIN_DATACONFIG,
  MODULE_PERMISSIONS.ADMIN_SUBSCRIPTION_PLAN_MANAGER,
  MODULE_PERMISSIONS.ADMIN_USERS
  // MODULE_PERMISSIONS.ADMIN_VARIABLE,
  // MODULE_PERMISSIONS.ADMIN_ACCOUNT,
  // MODULE_PERMISSIONS.ADMIN_USERS,
  // MODULE_PERMISSIONS.ADMIN_ADVERTISER,
];

const Creative = (props) => {

  const [paths, setPaths] = useState('');

  useEffect(() => {
    checkPathPermissions();
  }, [props.location.pathname]);

  const checkPathPermissions = () => {
    try {
      let availablePermissions = permissionArray.map((item) => checkPermission({ permissions: item })).filter((item) => item !== false);
      if (availablePermissions.length > 0) {
        let defaultPathArr = availablePermissions[0].split('::');
        let path = defaultPathArr[defaultPathArr.length - 1].trim().toLowerCase().replaceAll(' ', '-');
        // console.log(path,defaultPathArr);
        //---------
        if (path.includes('profile')) {
          setPaths('account')
        } else if (path.includes('connection')) {
          setPaths('connection')
        } else {
          setPaths(path);
        }
      } else {
        setPaths('not-authorize');
        // setPaths('tenant');
      }
    } catch (error) {
      console.log(error);
    }
  };


  return (
    <Switch>
      {/* <Route path={`${props.match.path}/${routes.admin.tenant.name}`} component={Tenant} />
    <Route path={`${props.match.path}/${routes.admin.supplyPartner.name}`} component={SupplyPartner} />
    <Route path={`${props.match.path}/${routes.admin.variable.name}`} component={Variable} />
    <Route path={`${props.match.path}/${routes.admin.user.name}`} component={User} />
    <Route path={`${props.match.path}/${routes.admin.features.name}`} component={Features} />
    <Route path={`${props.match.path}/${routes.admin.demandPartner.name}`} component={DemandPartner} />
  */}
      {/* <Route path={`${props.match.path}/${routes.admin.roles.name}`} component={Roles} /> */}
      <PrivateRoute path={`${props.match.path}/${routes.admin.tenant.name}`} component={Tenant}
        permissions={MODULE_PERMISSIONS.ADMIN_TENANT}
        defaultRoute={`/${routes.containers.admin}/${paths}`} />

      {/* <PrivateRoute path={`${props.match.path}/${routes.admin.supplyPartner.name}`} component={SupplyPartner}
      permissions={MODULE_PERMISSIONS.ADMIN_SUPPLYPARTNER}
    defaultRoute={`/${routes.containers.admin}/${paths}`} /> */}

      <PrivateRoute path={`${props.match.path}/${routes.admin.variable.name}`} component={Variable}
        // permissions={MODULE_PERMISSIONS.ADMIN_VARIABLE}
        defaultRoute={`/${routes.containers.admin}/${paths}`} />

      <PrivateRoute path={`${props.match.path}/${routes.admin.user.name}`} component={User}
        permissions={MODULE_PERMISSIONS.ADMIN_USERS}
        defaultRoute={`/${routes.containers.admin}/${paths}`} />


      {/* <PrivateRoute path={`${props.match.path}/${routes.admin.advertiser.name}`} component={Advertiser}
        permissions={MODULE_PERMISSIONS.ADMIN_ADVERTISER}
        defaultRoute={`/${routes.containers.admin}/${paths}`} /> */}

      {/* <PrivateRoute path={`${props.match.path}/${routes.admin.features.name}`} component={Features}
      permissions={MODULE_PERMISSIONS.ADMIN_FEATURES}
    defaultRoute={`/${routes.containers.admin}/${paths}`} /> */}

      {/* <PrivateRoute path={`${props.match.path}/${routes.admin.demandPartner.name}`} component={DemandPartner}
      permissions={MODULE_PERMISSIONS.ADMIN_DEMANDPARTNER}
      defaultRoute={`/${routes.containers.admin}/${paths}`} />
      
      <PrivateRoute path={`${props.match.path}/${routes.admin.roles.name}`} component={Roles}
      permissions={MODULE_PERMISSIONS.ADMIN_ROLES}
      defaultRoute={`/${routes.containers.admin}/${paths}`} />
      
      <PrivateRoute path={`${props.match.path}/${routes.admin.agreement.name}`} component={Agreement}
      permissions={MODULE_PERMISSIONS.ADMIN_AGREEMENT}
      defaultRoute={`/${routes.containers.admin}/${paths}`} />
      
      <PrivateRoute path={`${props.match.path}/${routes.admin.supplyPath.name}`} component={SupplyPath}
      permissions={MODULE_PERMISSIONS.ADMIN_SUPPLYPATH}
    defaultRoute={`/${routes.containers.admin}/${paths}`} /> */}

      <PrivateRoute path={`${props.match.path}/${routes.admin.account.name}`} component={Account}
        permissions={MODULE_PERMISSIONS.ADMIN_PROFILE}
        defaultRoute={`/${routes.containers.admin}/${paths}`} />

      {/* <PrivateRoute path={`${props.match.path}/${routes.admin.advertiser.poc}`} component={AdvertiserPoc}
        permissions={MODULE_PERMISSIONS.ADMIN_ADVERTISER}
        defaultRoute={`/${routes.containers.admin}/${paths}`} /> */}

      <Route path={`${props.match.path}/${routes.admin.connection.name}`} component={ConnectionManagement}
      // permissions={MODULE_PERMISSIONS.ADMIN_ADVERTISER}
      // defaultRoute={`/${routes.containers.admin}/${paths}`} 
      />


      <PrivateRoute path={`${props.match.path}/${routes.admin.subscriptionPlanMgr.name}`} component={SubscriptionPlanMgr}
        permissions={MODULE_PERMISSIONS.ADMIN_SUBSCRIPTION_PLAN_MANAGER}
        defaultRoute={`/${routes.containers.admin}/${paths}`} />

      <PrivateRoute path={`${props.match.path}/${routes.containers.dataConfig}`} component={DataConfig}
        permissions={MODULE_PERMISSIONS.ADMIN_DATACONFIG}
        defaultRoute={`/${routes.containers.admin}/${paths}`} />

      {/* <PrivateRoute path={`${props.match.path}/${routes.admin.currencyRate.name}`} component={CurrencyRate}
      permissions={MODULE_PERMISSIONS.ADMIN_VARIABLE}
      defaultRoute={'admin'} />
      <PrivateRoute path={`${props.match.path}/${routes.admin.platform.name}`} component={Platform}
      permissions={MODULE_PERMISSIONS.ADMIN_DEMANDPARTNER}
    defaultRoute={'admin'} /> */}
      {/* <Route path={`${props.match.path}/${routes.admin.supplyPath.name}`} component={SupplyPath} /> */}
      {/* <Route path={`${props.match.path}/${routes.admin.agreement.name}`} component={Agreement} /> */}

      <Route exact path={`${props.match.path}`} render={() => <Redirect to={`${props.match.path}/${paths}`} />} />
      <Route path={`${props.match.path}/${routes.notAuthorize}`} component={NotAuthorize} />
    </Switch>
  );
};

export default Creative;
